import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MARKETS, IMAGES } from "@/data/site";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useI18n } from "@/context/I18nContext";

const stats = [
  { value: "3+", label: "Export markets served" },
  { value: "10", label: "Product categories" },
  { value: "100%", label: "Sortex-clean grades" },
  { value: "24/7", label: "Buyer support" },
];

export default function GlobalReach() {
  const { t } = useI18n();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="global" ref={ref} data-testid="global-section" className="relative z-10 overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0 z-0 scale-110">
        <img src={IMAGES.ship} alt="Global cargo port" className="h-full w-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 z-0 bg-brand-ink/85" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 py-28 lg:py-40">
        <Reveal><Eyebrow>{t("glob_eyebrow")}</Eyebrow></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white max-w-3xl leading-[1.02]">
            {t("glob_title1")} <span className="text-brand-gold italic">{t("glob_title2")}</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-wrap gap-3" data-testid="markets-list">
            {MARKETS.map((m) => (
              <span key={m} className="rounded-full border border-white/20 bg-white/10 backdrop-blur px-6 py-2.5 text-sm text-white">{m}</span>
            ))}
            <span className="rounded-full border border-brand-gold/50 bg-brand-gold/20 px-6 py-2.5 text-sm text-brand-gold">{t("glob_new")}</span>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur p-7">
                <div className="font-display text-4xl sm:text-5xl text-brand-gold">{s.value}</div>
                <div className="mt-2 text-xs uppercase tracking-[0.18em] text-white/70">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
